export class DeliveryStaticData {
  public static readonly PICK_UP_URL: string = 'https://www.posten.no/motta/hente-selv';
}
